export default __webpack_public_path__ + "static/bg-page-xperiential-expo-dad6ceecd263c7eb224b268f7c8c43b0.jpg";